type Props = {
  items: string[];
};

function CheckCircleFilled() {
  return (
    <svg class="size-5 shrink-0 text-blue-600" viewBox="0 0 20 20" fill="currentColor">
      <path
        fill-rule="evenodd"
        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z"
        clip-rule="evenodd"
      />
    </svg>
  );
}

export function BenefitChecklist({ items }: Props) {
  return (
    <div class="flex flex-col gap-3 my-4">
      {items.map((item, i) => (
        <div
          key={i}
          class="flex items-center gap-3 bg-white rounded-full px-4 py-3 border border-gray-100 shadow-sm"
        >
          <CheckCircleFilled />
          <span class="text-gray-700 text-sm">{item}</span>
        </div>
      ))}
    </div>
  );
}
